import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-[#F8FAFC]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1FA3B5] mb-4">FAQ</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            Häufige Fragen, ehrliche Antworten.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Sie haben eine Frage, die hier nicht steht? Schreiben Sie uns einfach per WhatsApp.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-14"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-accordion-item-${i}`}
                className="bg-white rounded-2xl border border-slate-100 px-6 lg:px-8 hover:border-[#1FA3B5]/30 transition-colors"
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-base lg:text-lg text-slate-900 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
